import { CompaniesListItemProps } from "./CompaniesListItem.types"
import { ReactComponent as LocationPinIcon } from '../../../../../../../assets/vectors/location_on.svg';
import placeholderImage from '../../../../../../../assets/images/placeholder2.jpg';
import { CURRENT_API } from "../../../../../../../utils/api/api";

export default ({ company, ...props }: CompaniesListItemProps) => {

  return (
    <div className='dashboard-companies__map-list-item' {...props}>
      <div className='dashboard-companies__map-list-item-image-container'>
        <img src={company.logo ? `${CURRENT_API}/users/logo?url=${company.logo}` : placeholderImage} height={60} className='dashboard-companies__map-list-item-image' />
      </div>
      <div className='dashboard-companies__map-list-item-infos'>
        <span id='title'>{company.name}</span>
        <div className='dashboard-companies__map-list-item-infos-location'>
          <LocationPinIcon />
          <span>
            {company.city} 
            {company.distance && 
              <><strong> ·</strong> {company.distance.toFixed(1)} km</>
            }
          </span>
        </div>
        <p className='dashboard-companies__map-list-item-infos-description'>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Error, reprehenderit assumenda ducimus aut deleniti a autem ad repudiandae quam eligendi delectus fuga? Excepturi perferendis itaque, ea consequatur inventore quibusdam sapiente?
        </p>
      </div>
    </div>
  )
}